import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import i18n from '../../i18n';
import InputImages from '../../../src/components/widget/InputImages';
import HandleErrors from '../../utils/HandleErrors';
import { setExternalLink, getExternalLink, setOptional } from '../../actions/collection';
import CollectionFunnelEvents from '../../utils/collectionFunnelEvents';

const ExternalLink = (props) => {
    const { register, handleSubmit, errors, formState, setValue, getValues } = useForm();
    const regex = new RegExp(
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
    );
    const navigate = useNavigate();

    useEffect(() => {
        if (!formState.dirty) {
            props.getExternalLink().then((result) => setValue('external-link', result.payload.external_link));
        }
    }, []);

    useEffect(() => {
        if (!formState.dirty) {
            props.hasError(!formState.dirty && Boolean(!getValues('external-link')));
        } else {
            props.hasError(formState.dirtyFields.size !== 1);
        }
    }, [formState, getValues('external-link')]);

    const onSubmit = (data) => {
        const match = data['external-link'].match(regex);
        if (match) {
            const externalLink = { 'external-link': match.join(' ') };
            if (!_.isEmpty(externalLink)) {
                props.getSending(true);
                CollectionFunnelEvents.funnelProgress(4);
                props.setExternalLink(externalLink).then(() => {
                    navigate(location.pathname.replace(/[^/]*$/, 'step5'));
                    props.setOptional(true);
                });
            }
        }
    };

    const validateUrl = (value) => {
        const match = value.match(regex);
        if (!match) {
            return i18n.t('collection:your_must_enter');
        }
    };

    return (
        <form id="form-step-4" onSubmit={handleSubmit(onSubmit)}>
            <h2 className="title-external-link">{i18n.t('collection:how_does_your_home')}</h2>
            <div className="container-form-group">
                <div className="text-home">
                    <p>{i18n.t('collection:is_your_home')}</p>
                </div>
                <div className="form-group">
                    <div className="form-label">
                        <label htmlFor="url">{i18n.t('collection:your_link')}</label>
                    </div>
                    <InputImages
                        classContainer={classNames('form-entity', {
                            'form-entity-error': !_.isEmpty(errors['external-link'])
                        })}
                        classImageLeft="form-entity-icon"
                        imageLeft={<i className="icon-collection_link icon" />}
                    >
                        <input
                            id="external-link"
                            name="external-link"
                            ref={register({
                                validate: (value) => validateUrl(value)
                            })}
                            defaultValue={props.externalLink ? props.externalLink : ''}
                            placeholder={i18n.t('collection:link_placeholder')}
                        />
                    </InputImages>
                    {!_.isEmpty(errors['external-link']) &&
                        HandleErrors.renderErrors(errors['external-link'], errors['external-link'].message)}
                </div>
            </div>
        </form>
    );
};

ExternalLink.propTypes = {
    getSending: PropTypes.func,
    hasError: PropTypes.func,
    externalLink: PropTypes.string,
    setExternalLink: PropTypes.func,
    getExternalLink: PropTypes.func,
    setOptional: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
    setExternalLink: bindActionCreators(setExternalLink, dispatch),
    getExternalLink: bindActionCreators(getExternalLink, dispatch),
    setOptional: bindActionCreators(setOptional, dispatch)
});

const mapStateToProps = (state) => ({
    externalLink: state.collection.externalLink
});

export default connect(mapStateToProps, mapDispatchToProps)(ExternalLink);
